module.exports = __webpack_public_path__ + "static/media/450000plus.302e074f.png";